



























































import { Vue, Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import UserModule from '@/store/userModule.ts'
import UserAuthModel from '@/models/user/userAuthModel'
import Validation from '@/mixins/validation.ts'
import apiService from '@/services/apiService'

const userModule = getModule(UserModule)

@Component
export default class Login extends Mixins(Validation) {
  private model: UserAuthModel = new UserAuthModel()
  private valid: boolean = true
  private loading: boolean = false
  private dialog: boolean = false
  private requestPassword = ''
  isProduction = false

  private created() {
    this.$vuetify.theme.dark = true
    this.isProduction = localStorage.getItem('env') === 'prod' ? true : false
  }

  private SetEnvironment() {
    let environment = this.isProduction ? 'prod' : 'sandbox'
    localStorage.setItem('env', String(environment))
  }

  private async resetPassword() {
    try {
      await apiService.sendPasswordReset({
        emailAddress: this.requestPassword
      })
      this.dialog = false
    } catch {
      alert('Email address not recognised')
    }
  }

  private async login(): Promise<void> {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      this.loading = true

      try {
        await userModule.login(this.model)
        this.$vuetify.theme.dark = false
        this.$router.push({ name: 'home' })
      } catch {
        alert('Username or password was incorrect')
      }

      this.loading = false
    }
  }
}
